import { withNamespace } from "components/Form/FormikControls";
import {
  MobileTransactionalCreateSaleModalTabId,
  MobileTransactionalCreateSaleModalTabs,
} from "./constants";
import { FormStatus } from "constants/form";
import theme from "constants/theme";

export const getTabFields: (
  saleLotNamespace: string,
  consignmentNamespace: string,
  saleNamespace: string,
) => Record<MobileTransactionalCreateSaleModalTabId, string[]> = (
  saleLotNamespace,
  consignmentNamespace,
  saleNamespace,
) => ({
  [MobileTransactionalCreateSaleModalTabs.WHO]: [
    withNamespace(consignmentNamespace, "vendor_id"),
    withNamespace(saleLotNamespace, "buyer_id"),
  ],
  [MobileTransactionalCreateSaleModalTabs.WHAT]: [
    withNamespace(saleLotNamespace, "quantity"),
    withNamespace(saleLotNamespace, "product_id"),
    withNamespace(saleLotNamespace, "sex_id"),
    withNamespace(saleLotNamespace, "age_id"),
    withNamespace(saleLotNamespace, "breed_id"),
    withNamespace(saleLotNamespace, "quantity_progeny"),
    withNamespace(saleLotNamespace, "dentitionId"),
    withNamespace(saleLotNamespace, "draftingAttributes.tagNumber"),
    withNamespace(saleLotNamespace, "draftingAttributes.animalName"),
    withNamespace(saleLotNamespace, "marks"),
    withNamespace(saleLotNamespace, "labels"),
    withNamespace(saleLotNamespace, "category_id"),
    withNamespace(saleLotNamespace, "note"),
  ],
  [MobileTransactionalCreateSaleModalTabs.WHEN]: [
    withNamespace(saleNamespace, "date"),
  ],
  [MobileTransactionalCreateSaleModalTabs.PRICE]: [
    withNamespace(saleLotNamespace, "pricing_type_id"),
    withNamespace(saleLotNamespace, "unit_price"),
  ],
  [MobileTransactionalCreateSaleModalTabs.REVIEW]: [],
});

export const getTabStatusColor = tabStatus => {
  switch (tabStatus) {
    case FormStatus.ERROR:
      return theme.colors.error;
    case FormStatus.TOUCHED:
      return theme.colors.successGreen;
    case FormStatus.UNTOUCHED:
      return theme.colors.gray78;
    default:
      return null;
  }
};
